import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'
import { AssistantPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import { AssistantExpanded } from '@/routes/_app/-components/assistant/assistant-frame'

/**
 * The assistant's expanded view. The conversation itself lives in the `_app` shell (-dialogs/assistant.tsx) and draws
 * into the place this gives it, so opening and closing this moves the same live chat — docs/notes/app/assistant-panel.md.
 */
export const Route = createFileRoute('/@modal/assistant')({
  staticData: { slotScope: '/_app' },
  loader: ({ context }) => {
    // The server refuses these reads to whoever it gives no assistant; a deep link from such a user warms nothing.
    if (!context.queryClient.getQueryData(context.sessionUserQueryOptions.queryKey)?.assistantEnabled) return
    // query: direct the main router never matches a slot route, so no route context can hold the panel's reads
    // prefetch: speculative warmed beside the conversation, so the gate or the thread paints at once
    context.queryClient.query(trpc.agent.getTerms.queryOptions()).catch(noop)
    // query: direct the history is a standing column in this view (see above)
    // prefetch: speculative warms its first page, so the list paints at once and only refreshes behind it
    context.queryClient
      .infiniteQuery(trpc.agent.listThreads.infiniteQueryOptions({}, { getNextPageParam: (page) => page.nextCursor }))
      .catch(noop)
  },
  pendingComponent: AssistantPending,
  component: AssistantSlot,
})

function AssistantSlot() {
  const slot = useModalSlot(Route)
  return <AssistantExpanded open={slot.open} onOpenChange={slot.onOpenChange} />
}
